<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/*@import "./assets/css/main.css";*/
/*#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}*/
*{margin:0;padding:0;list-style-type:none;}
body{
  margin: 0;
}
a,a:hover,a:active,a:visited,a:link,a:focus{
  text-decoration: none;
}
li{
  list-style: none;
}
body .el-table th.gutter {
  display: table-cell !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue